/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * リクルタAI SaaS API
 * リクルタAI SaaS API仕様書
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { useCallback } from "react";
import { useCustomInstance } from "../../../libs/axios/index";
import type { ErrorType } from "../../../libs/axios/index";
import type {
	GetApiV1Selections200,
	GetApiV1SelectionsJobInformation200,
	GetApiV1SelectionsJobInformationParams,
	GetApiV1SelectionsParams,
	GetApiV1SelectionsSelectionId200,
	GetApiV1UsersMe200,
	PostApiV1SelectionsJobInformation200,
	PostApiV1SelectionsJobInformationBody,
	PostApiV1SelectionsSelectionIdApplicantResume200,
	PostApiV1SelectionsSelectionIdApplicantResumeBody,
	PostCommandsV1Body,
	PostCommandsV1200,
	PutApiV1SelectionsJobInformationJobInformationIdBody,
} from "./aISaaSAPI.schemas";

/**
 * ユーザー情報の取得
 */
export const useGetApiV1UsersMeHook = () => {
	const getApiV1UsersMe = useCustomInstance<GetApiV1UsersMe200>();

	return useCallback(
		(signal?: AbortSignal) => {
			return getApiV1UsersMe({
				url: `/api/v1/users/me`,
				method: "GET",
				signal,
			});
		},
		[getApiV1UsersMe],
	);
};

export const getGetApiV1UsersMeQueryKey = () => {
	return [`/api/v1/users/me`] as const;
};

export const useGetApiV1UsersMeQueryOptions = <
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
			TError,
			TData
		>
	>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiV1UsersMeQueryKey();

	const getApiV1UsersMe = useGetApiV1UsersMeHook();

	const queryFn: QueryFunction<
		Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>
	> = ({ signal }) => getApiV1UsersMe(signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV1UsersMeQueryResult = NonNullable<
	Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>
>;
export type GetApiV1UsersMeQueryError = ErrorType<unknown>;

export function useGetApiV1UsersMe<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
	TError = ErrorType<unknown>,
>(options: {
	query: Partial<
		UseQueryOptions<
			Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
			TError,
			TData
		>
	> &
		Pick<
			DefinedInitialDataOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
				TError,
				Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>
			>,
			"initialData"
		>;
}): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1UsersMe<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
			TError,
			TData
		>
	> &
		Pick<
			UndefinedInitialDataOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
				TError,
				Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>
			>,
			"initialData"
		>;
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1UsersMe<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
			TError,
			TData
		>
	>;
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiV1UsersMe<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
			TError,
			TData
		>
	>;
}): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = useGetApiV1UsersMeQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

export const useGetApiV1UsersMeSuspenseQueryOptions = <
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseSuspenseQueryOptions<
			Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
			TError,
			TData
		>
	>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetApiV1UsersMeQueryKey();

	const getApiV1UsersMe = useGetApiV1UsersMeHook();

	const queryFn: QueryFunction<
		Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>
	> = ({ signal }) => getApiV1UsersMe(signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV1UsersMeSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>
>;
export type GetApiV1UsersMeSuspenseQueryError = ErrorType<unknown>;

export function useGetApiV1UsersMeSuspense<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
	TError = ErrorType<unknown>,
>(options: {
	query: Partial<
		UseSuspenseQueryOptions<
			Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
			TError,
			TData
		>
	>;
}): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1UsersMeSuspense<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseSuspenseQueryOptions<
			Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
			TError,
			TData
		>
	>;
}): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1UsersMeSuspense<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseSuspenseQueryOptions<
			Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
			TError,
			TData
		>
	>;
}): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiV1UsersMeSuspense<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseSuspenseQueryOptions<
			Awaited<ReturnType<ReturnType<typeof useGetApiV1UsersMeHook>>>,
			TError,
			TData
		>
	>;
}): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = useGetApiV1UsersMeSuspenseQueryOptions(options);

	const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * 書類選考を実施。書類としてpdfをbase64で受け取る or テキストで受け取るためどちらかのデータは必須

レスポンスは受け取った側のデータも返却する
 */
export const usePostApiV1SelectionsSelectionIdApplicantResumeHook = () => {
	const postApiV1SelectionsSelectionIdApplicantResume =
		useCustomInstance<PostApiV1SelectionsSelectionIdApplicantResume200>();

	return useCallback(
		(
			selectionId: string,
			postApiV1SelectionsSelectionIdApplicantResumeBody: PostApiV1SelectionsSelectionIdApplicantResumeBody,
			signal?: AbortSignal,
		) => {
			return postApiV1SelectionsSelectionIdApplicantResume({
				url: `/api/v1/selections/${selectionId}/applicant/resume`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				data: postApiV1SelectionsSelectionIdApplicantResumeBody,
				signal,
			});
		},
		[postApiV1SelectionsSelectionIdApplicantResume],
	);
};

export const usePostApiV1SelectionsSelectionIdApplicantResumeMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<
			ReturnType<
				ReturnType<typeof usePostApiV1SelectionsSelectionIdApplicantResumeHook>
			>
		>,
		TError,
		{
			selectionId: string;
			data: PostApiV1SelectionsSelectionIdApplicantResumeBody;
		},
		TContext
	>;
}): UseMutationOptions<
	Awaited<
		ReturnType<
			ReturnType<typeof usePostApiV1SelectionsSelectionIdApplicantResumeHook>
		>
	>,
	TError,
	{
		selectionId: string;
		data: PostApiV1SelectionsSelectionIdApplicantResumeBody;
	},
	TContext
> => {
	const mutationKey = ["postApiV1SelectionsSelectionIdApplicantResume"];
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const postApiV1SelectionsSelectionIdApplicantResume =
		usePostApiV1SelectionsSelectionIdApplicantResumeHook();

	const mutationFn: MutationFunction<
		Awaited<
			ReturnType<
				ReturnType<typeof usePostApiV1SelectionsSelectionIdApplicantResumeHook>
			>
		>,
		{
			selectionId: string;
			data: PostApiV1SelectionsSelectionIdApplicantResumeBody;
		}
	> = (props) => {
		const { selectionId, data } = props ?? {};

		return postApiV1SelectionsSelectionIdApplicantResume(selectionId, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostApiV1SelectionsSelectionIdApplicantResumeMutationResult =
	NonNullable<
		Awaited<
			ReturnType<
				ReturnType<typeof usePostApiV1SelectionsSelectionIdApplicantResumeHook>
			>
		>
	>;
export type PostApiV1SelectionsSelectionIdApplicantResumeMutationBody =
	PostApiV1SelectionsSelectionIdApplicantResumeBody;
export type PostApiV1SelectionsSelectionIdApplicantResumeMutationError =
	ErrorType<unknown>;

export const usePostApiV1SelectionsSelectionIdApplicantResume = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<
			ReturnType<
				ReturnType<typeof usePostApiV1SelectionsSelectionIdApplicantResumeHook>
			>
		>,
		TError,
		{
			selectionId: string;
			data: PostApiV1SelectionsSelectionIdApplicantResumeBody;
		},
		TContext
	>;
}): UseMutationResult<
	Awaited<
		ReturnType<
			ReturnType<typeof usePostApiV1SelectionsSelectionIdApplicantResumeHook>
		>
	>,
	TError,
	{
		selectionId: string;
		data: PostApiV1SelectionsSelectionIdApplicantResumeBody;
	},
	TContext
> => {
	const mutationOptions =
		usePostApiV1SelectionsSelectionIdApplicantResumeMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * 全ての求人情報一覧を取得
 */
export const useGetApiV1SelectionsJobInformationHook = () => {
	const getApiV1SelectionsJobInformation =
		useCustomInstance<GetApiV1SelectionsJobInformation200>();

	return useCallback(
		(params: GetApiV1SelectionsJobInformationParams, signal?: AbortSignal) => {
			return getApiV1SelectionsJobInformation({
				url: `/api/v1/selections/job-information`,
				method: "GET",
				params,
				signal,
			});
		},
		[getApiV1SelectionsJobInformation],
	);
};

export const getGetApiV1SelectionsJobInformationQueryKey = (
	params: GetApiV1SelectionsJobInformationParams,
) => {
	return [
		`/api/v1/selections/job-information`,
		...(params ? [params] : []),
	] as const;
};

export const useGetApiV1SelectionsJobInformationQueryOptions = <
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsJobInformationParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
				>,
				TError,
				TData
			>
		>;
	},
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetApiV1SelectionsJobInformationQueryKey(params);

	const getApiV1SelectionsJobInformation =
		useGetApiV1SelectionsJobInformationHook();

	const queryFn: QueryFunction<
		Awaited<
			ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
		>
	> = ({ signal }) => getApiV1SelectionsJobInformation(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<
			ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
		>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV1SelectionsJobInformationQueryResult = NonNullable<
	Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>
>;
export type GetApiV1SelectionsJobInformationQueryError = ErrorType<unknown>;

export function useGetApiV1SelectionsJobInformation<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsJobInformationParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							ReturnType<typeof useGetApiV1SelectionsJobInformationHook>
						>
					>,
					TError,
					Awaited<
						ReturnType<
							ReturnType<typeof useGetApiV1SelectionsJobInformationHook>
						>
					>
				>,
				"initialData"
			>;
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1SelectionsJobInformation<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsJobInformationParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							ReturnType<typeof useGetApiV1SelectionsJobInformationHook>
						>
					>,
					TError,
					Awaited<
						ReturnType<
							ReturnType<typeof useGetApiV1SelectionsJobInformationHook>
						>
					>
				>,
				"initialData"
			>;
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1SelectionsJobInformation<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsJobInformationParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiV1SelectionsJobInformation<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsJobInformationParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = useGetApiV1SelectionsJobInformationQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

export const useGetApiV1SelectionsJobInformationSuspenseQueryOptions = <
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsJobInformationParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
				>,
				TError,
				TData
			>
		>;
	},
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetApiV1SelectionsJobInformationQueryKey(params);

	const getApiV1SelectionsJobInformation =
		useGetApiV1SelectionsJobInformationHook();

	const queryFn: QueryFunction<
		Awaited<
			ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
		>
	> = ({ signal }) => getApiV1SelectionsJobInformation(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<
			ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
		>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV1SelectionsJobInformationSuspenseQueryResult = NonNullable<
	Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>
>;
export type GetApiV1SelectionsJobInformationSuspenseQueryError =
	ErrorType<unknown>;

export function useGetApiV1SelectionsJobInformationSuspense<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsJobInformationParams,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1SelectionsJobInformationSuspense<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsJobInformationParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1SelectionsJobInformationSuspense<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsJobInformationParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiV1SelectionsJobInformationSuspense<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
	>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsJobInformationParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsJobInformationHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = useGetApiV1SelectionsJobInformationSuspenseQueryOptions(
		params,
		options,
	);

	const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * 求人情報を作成。urlベースとtextベースがあるためどちらかは必須
 */
export const usePostApiV1SelectionsJobInformationHook = () => {
	const postApiV1SelectionsJobInformation =
		useCustomInstance<PostApiV1SelectionsJobInformation200>();

	return useCallback(
		(
			postApiV1SelectionsJobInformationBody: PostApiV1SelectionsJobInformationBody,
			signal?: AbortSignal,
		) => {
			return postApiV1SelectionsJobInformation({
				url: `/api/v1/selections/job-information`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				data: postApiV1SelectionsJobInformationBody,
				signal,
			});
		},
		[postApiV1SelectionsJobInformation],
	);
};

export const usePostApiV1SelectionsJobInformationMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<
			ReturnType<ReturnType<typeof usePostApiV1SelectionsJobInformationHook>>
		>,
		TError,
		{ data: PostApiV1SelectionsJobInformationBody },
		TContext
	>;
}): UseMutationOptions<
	Awaited<
		ReturnType<ReturnType<typeof usePostApiV1SelectionsJobInformationHook>>
	>,
	TError,
	{ data: PostApiV1SelectionsJobInformationBody },
	TContext
> => {
	const mutationKey = ["postApiV1SelectionsJobInformation"];
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const postApiV1SelectionsJobInformation =
		usePostApiV1SelectionsJobInformationHook();

	const mutationFn: MutationFunction<
		Awaited<
			ReturnType<ReturnType<typeof usePostApiV1SelectionsJobInformationHook>>
		>,
		{ data: PostApiV1SelectionsJobInformationBody }
	> = (props) => {
		const { data } = props ?? {};

		return postApiV1SelectionsJobInformation(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostApiV1SelectionsJobInformationMutationResult = NonNullable<
	Awaited<
		ReturnType<ReturnType<typeof usePostApiV1SelectionsJobInformationHook>>
	>
>;
export type PostApiV1SelectionsJobInformationMutationBody =
	PostApiV1SelectionsJobInformationBody;
export type PostApiV1SelectionsJobInformationMutationError = ErrorType<unknown>;

export const usePostApiV1SelectionsJobInformation = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<
			ReturnType<ReturnType<typeof usePostApiV1SelectionsJobInformationHook>>
		>,
		TError,
		{ data: PostApiV1SelectionsJobInformationBody },
		TContext
	>;
}): UseMutationResult<
	Awaited<
		ReturnType<ReturnType<typeof usePostApiV1SelectionsJobInformationHook>>
	>,
	TError,
	{ data: PostApiV1SelectionsJobInformationBody },
	TContext
> => {
	const mutationOptions =
		usePostApiV1SelectionsJobInformationMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * 求人情報を更新
 */
export const usePutApiV1SelectionsJobInformationJobInformationIdHook = () => {
	const putApiV1SelectionsJobInformationJobInformationId =
		useCustomInstance<void>();

	return useCallback(
		(
			jobInformationId: string,
			putApiV1SelectionsJobInformationJobInformationIdBody: PutApiV1SelectionsJobInformationJobInformationIdBody,
		) => {
			return putApiV1SelectionsJobInformationJobInformationId({
				url: `/api/v1/selections/job-information/${jobInformationId}`,
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				data: putApiV1SelectionsJobInformationJobInformationIdBody,
			});
		},
		[putApiV1SelectionsJobInformationJobInformationId],
	);
};

export const usePutApiV1SelectionsJobInformationJobInformationIdMutationOptions =
	<TError = ErrorType<unknown>, TContext = unknown>(options?: {
		mutation?: UseMutationOptions<
			Awaited<
				ReturnType<
					ReturnType<
						typeof usePutApiV1SelectionsJobInformationJobInformationIdHook
					>
				>
			>,
			TError,
			{
				jobInformationId: string;
				data: PutApiV1SelectionsJobInformationJobInformationIdBody;
			},
			TContext
		>;
	}): UseMutationOptions<
		Awaited<
			ReturnType<
				ReturnType<
					typeof usePutApiV1SelectionsJobInformationJobInformationIdHook
				>
			>
		>,
		TError,
		{
			jobInformationId: string;
			data: PutApiV1SelectionsJobInformationJobInformationIdBody;
		},
		TContext
	> => {
		const mutationKey = ["putApiV1SelectionsJobInformationJobInformationId"];
		const { mutation: mutationOptions } = options
			? options.mutation &&
				"mutationKey" in options.mutation &&
				options.mutation.mutationKey
				? options
				: { ...options, mutation: { ...options.mutation, mutationKey } }
			: { mutation: { mutationKey } };

		const putApiV1SelectionsJobInformationJobInformationId =
			usePutApiV1SelectionsJobInformationJobInformationIdHook();

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<
					ReturnType<
						typeof usePutApiV1SelectionsJobInformationJobInformationIdHook
					>
				>
			>,
			{
				jobInformationId: string;
				data: PutApiV1SelectionsJobInformationJobInformationIdBody;
			}
		> = (props) => {
			const { jobInformationId, data } = props ?? {};

			return putApiV1SelectionsJobInformationJobInformationId(
				jobInformationId,
				data,
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type PutApiV1SelectionsJobInformationJobInformationIdMutationResult =
	NonNullable<
		Awaited<
			ReturnType<
				ReturnType<
					typeof usePutApiV1SelectionsJobInformationJobInformationIdHook
				>
			>
		>
	>;
export type PutApiV1SelectionsJobInformationJobInformationIdMutationBody =
	PutApiV1SelectionsJobInformationJobInformationIdBody;
export type PutApiV1SelectionsJobInformationJobInformationIdMutationError =
	ErrorType<unknown>;

export const usePutApiV1SelectionsJobInformationJobInformationId = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<
			ReturnType<
				ReturnType<
					typeof usePutApiV1SelectionsJobInformationJobInformationIdHook
				>
			>
		>,
		TError,
		{
			jobInformationId: string;
			data: PutApiV1SelectionsJobInformationJobInformationIdBody;
		},
		TContext
	>;
}): UseMutationResult<
	Awaited<
		ReturnType<
			ReturnType<typeof usePutApiV1SelectionsJobInformationJobInformationIdHook>
		>
	>,
	TError,
	{
		jobInformationId: string;
		data: PutApiV1SelectionsJobInformationJobInformationIdBody;
	},
	TContext
> => {
	const mutationOptions =
		usePutApiV1SelectionsJobInformationJobInformationIdMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * 求人情報一覧を取得
 */
export const useGetApiV1SelectionsHook = () => {
	const getApiV1Selections = useCustomInstance<GetApiV1Selections200>();

	return useCallback(
		(params: GetApiV1SelectionsParams, signal?: AbortSignal) => {
			return getApiV1Selections({
				url: `/api/v1/selections`,
				method: "GET",
				params,
				signal,
			});
		},
		[getApiV1Selections],
	);
};

export const getGetApiV1SelectionsQueryKey = (
	params: GetApiV1SelectionsParams,
) => {
	return [`/api/v1/selections`, ...(params ? [params] : [])] as const;
};

export const useGetApiV1SelectionsQueryOptions = <
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
				TError,
				TData
			>
		>;
	},
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetApiV1SelectionsQueryKey(params);

	const getApiV1Selections = useGetApiV1SelectionsHook();

	const queryFn: QueryFunction<
		Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>
	> = ({ signal }) => getApiV1Selections(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV1SelectionsQueryResult = NonNullable<
	Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>
>;
export type GetApiV1SelectionsQueryError = ErrorType<unknown>;

export function useGetApiV1Selections<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
					TError,
					Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>
				>,
				"initialData"
			>;
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1Selections<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
					TError,
					Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>
				>,
				"initialData"
			>;
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1Selections<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
				TError,
				TData
			>
		>;
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiV1Selections<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
				TError,
				TData
			>
		>;
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = useGetApiV1SelectionsQueryOptions(params, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

export const useGetApiV1SelectionsSuspenseQueryOptions = <
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
				TError,
				TData
			>
		>;
	},
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetApiV1SelectionsQueryKey(params);

	const getApiV1Selections = useGetApiV1SelectionsHook();

	const queryFn: QueryFunction<
		Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>
	> = ({ signal }) => getApiV1Selections(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV1SelectionsSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>
>;
export type GetApiV1SelectionsSuspenseQueryError = ErrorType<unknown>;

export function useGetApiV1SelectionsSuspense<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsParams,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1SelectionsSuspense<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1SelectionsSuspense<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiV1SelectionsSuspense<
	TData = Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
	TError = ErrorType<unknown>,
>(
	params: GetApiV1SelectionsParams,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsHook>>>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = useGetApiV1SelectionsSuspenseQueryOptions(
		params,
		options,
	);

	const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * 選考情報IDから選考情報を取得
 */
export const useGetApiV1SelectionsSelectionIdHook = () => {
	const getApiV1SelectionsSelectionId =
		useCustomInstance<GetApiV1SelectionsSelectionId200>();

	return useCallback(
		(selectionId: string, signal?: AbortSignal) => {
			return getApiV1SelectionsSelectionId({
				url: `/api/v1/selections/${selectionId}`,
				method: "GET",
				signal,
			});
		},
		[getApiV1SelectionsSelectionId],
	);
};

export const getGetApiV1SelectionsSelectionIdQueryKey = (
	selectionId: string,
) => {
	return [`/api/v1/selections/${selectionId}`] as const;
};

export const useGetApiV1SelectionsSelectionIdQueryOptions = <
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
	>,
	TError = ErrorType<unknown>,
>(
	selectionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
				>,
				TError,
				TData
			>
		>;
	},
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetApiV1SelectionsSelectionIdQueryKey(selectionId);

	const getApiV1SelectionsSelectionId = useGetApiV1SelectionsSelectionIdHook();

	const queryFn: QueryFunction<
		Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>>
	> = ({ signal }) => getApiV1SelectionsSelectionId(selectionId, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!selectionId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<
			ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
		>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV1SelectionsSelectionIdQueryResult = NonNullable<
	Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>>
>;
export type GetApiV1SelectionsSelectionIdQueryError = ErrorType<unknown>;

export function useGetApiV1SelectionsSelectionId<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
	>,
	TError = ErrorType<unknown>,
>(
	selectionId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
					>,
					TError,
					Awaited<
						ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
					>
				>,
				"initialData"
			>;
	},
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1SelectionsSelectionId<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
	>,
	TError = ErrorType<unknown>,
>(
	selectionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
					>,
					TError,
					Awaited<
						ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
					>
				>,
				"initialData"
			>;
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1SelectionsSelectionId<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
	>,
	TError = ErrorType<unknown>,
>(
	selectionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiV1SelectionsSelectionId<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
	>,
	TError = ErrorType<unknown>,
>(
	selectionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = useGetApiV1SelectionsSelectionIdQueryOptions(
		selectionId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
}

export const useGetApiV1SelectionsSelectionIdSuspenseQueryOptions = <
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
	>,
	TError = ErrorType<unknown>,
>(
	selectionId: string,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
				>,
				TError,
				TData
			>
		>;
	},
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetApiV1SelectionsSelectionIdQueryKey(selectionId);

	const getApiV1SelectionsSelectionId = useGetApiV1SelectionsSelectionIdHook();

	const queryFn: QueryFunction<
		Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>>
	> = ({ signal }) => getApiV1SelectionsSelectionId(selectionId, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<
			ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
		>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV1SelectionsSelectionIdSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>>
>;
export type GetApiV1SelectionsSelectionIdSuspenseQueryError =
	ErrorType<unknown>;

export function useGetApiV1SelectionsSelectionIdSuspense<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
	>,
	TError = ErrorType<unknown>,
>(
	selectionId: string,
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1SelectionsSelectionIdSuspense<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
	>,
	TError = ErrorType<unknown>,
>(
	selectionId: string,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiV1SelectionsSelectionIdSuspense<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
	>,
	TError = ErrorType<unknown>,
>(
	selectionId: string,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiV1SelectionsSelectionIdSuspense<
	TData = Awaited<
		ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
	>,
	TError = ErrorType<unknown>,
>(
	selectionId: string,
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<
					ReturnType<ReturnType<typeof useGetApiV1SelectionsSelectionIdHook>>
				>,
				TError,
				TData
			>
		>;
	},
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = useGetApiV1SelectionsSelectionIdSuspenseQueryOptions(
		selectionId,
		options,
	);

	const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * コマンドを実行
 */
export const usePostCommandsV1Hook = () => {
	const postCommandsV1 = useCustomInstance<PostCommandsV1200>();

	return useCallback(
		(postCommandsV1Body: PostCommandsV1Body, signal?: AbortSignal) => {
			return postCommandsV1({
				url: `/commands/v1`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				data: postCommandsV1Body,
				signal,
			});
		},
		[postCommandsV1],
	);
};

export const usePostCommandsV1MutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<ReturnType<typeof usePostCommandsV1Hook>>>,
		TError,
		{ data: PostCommandsV1Body },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<ReturnType<typeof usePostCommandsV1Hook>>>,
	TError,
	{ data: PostCommandsV1Body },
	TContext
> => {
	const mutationKey = ["postCommandsV1"];
	const { mutation: mutationOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const postCommandsV1 = usePostCommandsV1Hook();

	const mutationFn: MutationFunction<
		Awaited<ReturnType<ReturnType<typeof usePostCommandsV1Hook>>>,
		{ data: PostCommandsV1Body }
	> = (props) => {
		const { data } = props ?? {};

		return postCommandsV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostCommandsV1MutationResult = NonNullable<
	Awaited<ReturnType<ReturnType<typeof usePostCommandsV1Hook>>>
>;
export type PostCommandsV1MutationBody = PostCommandsV1Body;
export type PostCommandsV1MutationError = ErrorType<unknown>;

export const usePostCommandsV1 = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<ReturnType<typeof usePostCommandsV1Hook>>>,
		TError,
		{ data: PostCommandsV1Body },
		TContext
	>;
}): UseMutationResult<
	Awaited<ReturnType<ReturnType<typeof usePostCommandsV1Hook>>>,
	TError,
	{ data: PostCommandsV1Body },
	TContext
> => {
	const mutationOptions = usePostCommandsV1MutationOptions(options);

	return useMutation(mutationOptions);
};
